import { FC } from 'react';

import { EquipmentStatus, StatusChip } from '@gasbi/shared';
import { useTranslation } from 'react-i18next';

import { GasConsumptionEquipmentStatusType } from '@/features/meteringPoints/types/gas-metering-node.types';

const getStatusChipProps = (id: EquipmentStatus): string | null => {
  const statusMap = {
    [EquipmentStatus.NotDefined]: 'grey',
    [EquipmentStatus.Disconnected]: 'yellow',
    [EquipmentStatus.InOperation]: 'green',
    [EquipmentStatus.Liquidated]: 'red',
  };
  return statusMap[id] ?? null;
};

type EquipmentStatusChipProps = {
  status: GasConsumptionEquipmentStatusType;
};

export const EquipmentStatusChip: FC<EquipmentStatusChipProps> = ({
  status,
}) => {
  const { t } = useTranslation();

  return (
    <StatusChip
      color={getStatusChipProps(status)}
      title={t(`GasConsumptionEquipmentStatus.${status}`)}
    />
  );
};
